
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 15 15","fill":"#4E6492"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 7.5c0 4.14-3.36 7.5-7.5 7.5C3.36 15 0 11.64 0 7.5 0 3.36 3.36 0 7.5 0 11.64 0 15 3.36 15 7.5zm0 0"}}),_c('path',{attrs:{"d":"M10.738 9.04c-.062 0-.117.05-.172.163-.64 1.3-1.746 2.219-3.027 2.219-1.48 0-2.394-1.336-2.394-3.18 0-3.125 1.742-4.933 3.27-4.933.714 0 1.151.449 1.151 1.164 0 .847-.48 1.297-.48 1.597 0 .133.082.215.246.215.668 0 1.45-.765 1.45-1.844 0-1.046-.915-1.82-2.442-1.82-2.527 0-4.774 2.344-4.774 5.586 0 2.512 1.434 4.168 3.645 4.168 2.344 0 3.703-2.332 3.703-3.09 0-.168-.086-.246-.176-.246zm0 0","fill":"#fff"}})])
          )
        }
      }
    